import { z } from 'zod'

export const KuroSitePostSummarySchema = z.object({
  slug: z.string(),
  title: z.string(),
  publishedAt: z.string(),
  updatedAt: z.string().optional(),
  excerpt: z.string(),
  tags: z.array(z.string()),
})

export const KuroSiteOverviewSchema = z.object({
  now: z.object({
    title: z.string(),
    updatedAt: z.string(),
    excerpt: z.string(),
  }),
  recentPosts: z.array(KuroSitePostSummarySchema),
  stats: z.object({
    postCount: z.number(),
    tagCount: z.number().optional(),
  }),
})

export const KuroSiteNowSchema = z.object({
  title: z.string(),
  updatedAt: z.string(),
  sections: z.array(
    z.object({
      heading: z.string(),
      body: z.string(),
    })
  ),
})

export const KuroSitePostsIndexSchema = z.object({
  posts: z.array(KuroSitePostSummarySchema),
})

export const KuroSitePostDetailSchema = z.object({
  slug: z.string(),
  title: z.string(),
  publishedAt: z.string(),
  updatedAt: z.string().optional(),
  tags: z.array(z.string()),
  excerpt: z.string(),
  contentHtml: z.string(),
  readingTimeMinutes: z.number().optional(),
})
